import { apiRequest } from '../../../api/client';
import type { NotificationListResponseDto } from '../types/notification';

export function listNotifications(limit = 20) {
  const params = new URLSearchParams({ limit: String(limit) });
  return apiRequest<NotificationListResponseDto>(`/v1/notifications?${params.toString()}`);
}

export function markNotificationRead(notificationId: string) {
  return apiRequest<{ notification_id: string; read: boolean; changed: boolean }>(
    `/v1/notifications/${encodeURIComponent(notificationId)}`,
    { method: 'PATCH', body: JSON.stringify({ read: true }) },
  );
}

export function markAllNotificationsRead() {
  return apiRequest<{ read: boolean; updated_count: number }>('/v1/notifications/read-all', {
    method: 'POST',
    body: JSON.stringify({}),
  });
}
